import firebase from "firebase";

/**
 * UploadImage()
 * upload the image to fireStorage
 * Method : PUT
 */
export const UploadImage = model => {
  const filename = model.Name;
  return firebase
    .storage()
    .ref("ProfileImages/" + filename)
    .put(model.Blob);
};
